const TotpIssuer = 'Joko';

export function createTotpUri(username: string, secret: string) {
    const label = encodeURIComponent(`${TotpIssuer}:${username}`);
    return `otpauth://totp/${label}?secret=${encodeURIComponent(secret)}&issuer=${encodeURIComponent(TotpIssuer)}`;
}
